import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import RecoverPasswordService from '../../services/RecoverPasswordService'
import { CircularProgress } from '@mui/material'
import useSignIn from 'react-auth-kit/hooks/useSignIn'
import { AuthenticatedUserData, LoginResponse } from '../../models/auth'
import { AppRoutes } from '../../helpers/routes'
import { useSnackbar } from 'notistack'
import CustomPaper from '../../containers/Paper'
import CustomButton from '../../components/Button'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'

const ActivateUserPage = () => {
    const navigate = useNavigate()
    const signIn = useSignIn()
    const { enqueueSnackbar } = useSnackbar()
    const { token } = useParams<{ token: string }>()
    const [loading, setLoading] = useState<boolean>(true)

    useEffect(() => {
        if (!token) return
        new RecoverPasswordService().activateUser(token).then((response) => {
            if (response.status === 200) {
                const userData: LoginResponse = response.data
                if (userData.validated && userData.approved) {
                    signIn({
                        auth: { token: userData.token, type: 'Bearer' },
                        userState: {
                            picture: userData.picture,
                            fullName: userData.fullName,
                        } as AuthenticatedUserData,
                    })
                    navigate(AppRoutes.home)
                } else setLoading(false)
            } else if (response.status === 401) {
                localStorage.setItem('error', '1')

                navigate(AppRoutes.home)
            } else {
                enqueueSnackbar(response.statusText, {
                    variant: 'error',
                    autoHideDuration: 6000,
                })
                console.error('Error activating user:', response)
            }
        })
    }, [navigate, token, enqueueSnackbar, signIn])

    return (
        <div className="flex flex-col justify-center items-center w-full h-full gap-8 md:gap-16">
            {loading ? (
                <CircularProgress size={128} />
            ) : (
                <CustomPaper className="w-[70vw] md:w-[40vw] p-3 md:p-6 text-primary flex flex-col gap-3 md:gap-8">
                    <span className="w-full text-center text-xl md:text-4xl font-bold">
                        Usuario pendiente de aprobación
                    </span>
                    <div className="flex gap-2 md:gap-6 mx-2 items-center justify-center">
                        <div className="flex gap-2 md:gap-6 flex-col">
                            <span className="text-base md:text-2xl font-semibold">
                                El email se validó correctamente y ahora tu usuario necesita ser
                                aprobado por un administrador.
                            </span>
                            <span className="text-sm md:text-xl">
                                Se te informará por correo cuando esto suceda.
                            </span>
                        </div>
                        <VerifiedUserIcon className="text-[75px] md:text-[200px] text-alert" />
                    </div>
                    <CustomButton
                        text="Volver al inicio"
                        onClick={() => navigate(AppRoutes.login)}
                    />
                </CustomPaper>
            )}
        </div>
    )
}

export default ActivateUserPage
